<template>
  <div class="app-nav-container">
    <div class="AppNavbar" :class="sidebarToggle ? '' : 'activenav'">
      <div class="left flex items-center gap-5">
        <!-- <img src="@/assets/img/Emblem_of_Uzbekistan.svg">
            <h1> {{$t('app_name')}} <span style="color:yellow;">[ beta ]</span> </h1> -->
        <button @click="setSidebarToggle()" class="lg:hidden xl:inline-block">
          <iconBurger />
        </button>
        <h1 class="hidden sm:block">{{ findName() }}</h1>
      </div>
      <div class="right">
        <el-dropdown size="small" trigger="click">
          <button
        
            class="bg-white border border-slate-200 rounded-xl px-3 py-0.5"
            v-if="$i18n.locale == 'cyr'"
            ><img
              style="width:34px;"
              src="@/assets/img/uzb.svg"/>
          </button>
          <button  class="bg-white border border-slate-200 rounded-xl px-3 py-0.5" v-else
            ><img
              style="width:34px;"
              src="@/assets/img/oris.svg"/>
          </button>
          <template #dropdown>
            <el-dropdown-menu>

              <el-dropdown-item>
                <div
                  @click="$i18n.locale = 'cyr'"
                  style="display: flex;align-items: center;justify-content: flex-start;"
                >
                  Ўзбекча
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div
                  @click="$i18n.locale = 'ru'"
                  style="display: flex;align-items: center;justify-content: flex-start;"
                >
                  Русский
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-dropdown size="small" trigger="click">
          <button
            class="w-10 h-10 rounded-xl border border-slate-200 overflow-hidden"
            style="margin-left: 10px;"
          >
            <div class="" style="background: #ECEFF1;">
              <img
                :src="
                  obj.profile_for_user.image
                    ? obj.profile_for_user.image
                    : require('@/assets/img/icons/freeuser.svg')
                "
                class="w-full h-full object-contain"
              />
            </div>
          </button>
          <template #dropdown>
            <el-dropdown-menu>
                <div
                  @click="$router.push('/me')"
                  class="bg-slate-50 hover:bg-slate-100 cursor-pointer flex items-center justify-between gap-2 mx-4 mt-2.5 rounded-xl px-4 py-2"
                >
                  {{ $t("accaunt") }}
                  <HUserRectangle class="text-indigo-800"/>
                </div>
                <div
                  @click="logout()"
                  class="bg-rose-50 hover:bg-rose-100 cursor-pointer flex items-center justify-between gap-2 text-red-600 mx-4 mt-3 mb-2.5 rounded-xl px-4 py-2"
                >
                  
                  {{ $t("logout") }}
                  <HLogOut01/>
                </div>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import HLogOut01 from "./Icons/hLogOut01.vue";
import HUserRectangle from "./Icons/hUserRectangle.vue";
import iconBurger from "./Icons/iconBurger.vue";
export default {
  components: {
    iconBurger,
    HUserRectangle,
    HLogOut01
  },
  data() {
    return {
      obj: {
        profile_for_user: {},
      },
    };
  },
  computed: {
    me() {
      return this.$store.state.me;
    },
    sidebarToggle() {
      return this.$store.state.sidebarToggle;
    },
    routerLinkes() {
      let data = {
        me: this.$t("users"),
        statistica: this.$t("statistics"),
        home: this.$t("statistics"),
        report: this.$t("report"),
        org: this.$t("organizations"),
        object: this.$t("objects"),
        obj: this.$t("objects"),
        building: this.$t("buildings"),
        reconstruction: this.$t("buildings"),
        build: this.$t("buildings"),
        "unconfirmed-buildings": this.$t("unconfirmed_buildings"),
        transport: this.$t("transport_facilities"),
        investment: this.$t("investment_project"),
        user: this.$t("users"),

        help: this.$t("help"),
        about: this.$t("about"),

        reservoir: this.$t("reservoirs"),
        water: this.$t("reservoirs"),
        hydrounit: this.$t("reservoirs"),
        pumpingstation: this.$t("reservoirs"),
      };
      return data;
    },
  },
  watch: {
    me() {
      if (this.me.id) {
        this._Get();
      }
    },
  },
  methods: {
    setSidebarToggle() {
      this.$store.commit("setSidebarToggle", !this.sidebarToggle);
    },
    logout() {
      axios.post("/logout/", {
        refresh: localStorage.refresh,
      });
      // this.$store.commit('get_me', { organization: {} })
      localStorage.token = "";
      localStorage.refresh = "";
      localStorage.role = "";
      this.$router.push("/login").catch((e) => {
        if (
          e.name !== "NavigationDuplicated" &&
          !e.message.includes(
            "Avoided redundant navigation to current location"
          )
        ) {
          console.log(e);
        }
      });
    },
    _Get() {
      this.loading = true;
      axios
        .get(`/users/${this.me.id}/`)
        .then((response) => {
          delete response.data.profile_for_user.user;
          this.img = response.data.profile_for_user.image;
          this.obj = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    findName() {
      let data = "";
      for (let i of Object.keys(this.routerLinkes)) {
        if (this.$route.name.includes(i)) {
          data = this.routerLinkes[i];
        }
      }
      return data;
    },
  },
  mounted() {
    // if (this.me.id) {
    //     this._Get()
    // }

    this.$root.$on("ChangeImage", () => {
      return this._Get();
    });
  },
};
</script>

<style lang="scss">
.AppNavbar {
  position: fixed;
  z-index: 1000;
  padding-left: 300px;
  z-index: 10;
  top: 0;
  left: 0;
  transition: all 0.2s linear;
  max-width: 2000px;

  &.activenav {
    padding-left: 100px;
  }

  .el-dropdown-menu__item {
    display: flex;
    align-items: center;

    img {
      margin-right: 5px;
    }
  }

  .el-button {
    span {
      display: flex;
      align-items: center;

      img {
        margin-right: 5px;
      }
    }
  }
  @media screen and (max-width: 1280px) {
    padding-left: 100px;
  }
  @media screen and (max-width: 1023px) {
    padding-left: 0;
    &.activenav {
      padding-left: 0;
    }
  }
}

@media screen and (min-width: 2000px) {
  .AppNavbar {
    top: 0;
    left: auto;
    padding-left: 0px;

    &.activenav {
      padding-left: 0px;
    }
  }
}
</style>
<style lang="scss" scoped>
.app-nav-container {
  height: 90px;
  left: 0;
}


.AppNavbar {
  padding-top: 20px;
  background: #f8fafc;
  height: 70px;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: space-between;

  // border-bottom: 1px solid #eeee;
  .left {
    padding-left: 20px;
    display: flex;
    align-items: center;
    height: 100%;

    h1 {
      font-weight: 600;
      color: #3730a3;
      font-size: 20px;
    }
  }

  .right {
    height: 100%;
    padding-right: 20px;
    display: flex;
    align-items: center;
  }

  h1 {
    font-weight: 500;
    font-size: 16px;
    max-width: 700px;
    text-align: left;
    line-height: 17px;
    color: #f4f4f4;
  }
}

.user-img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
}

.user-img img {
  width: 100%;
  object-position: center;
}

.user-lenk-button {
  padding: 0;
  padding: 0 10px;
  height: 40px;
}
</style>
